<template>
  <div class="main">
    <b-form @submit="onSubmit" @reset="onReset">
      <div class="utenza">
        <div class="label">Inserisci ID Cliente</div>
        <b-form-input class="input" v-model="form.contratto" placeholder="Es: 87631687" type="number"></b-form-input>
        <div class="label">Numero contatore</div>
        <b-form-input class="input" v-model="form.contatore" placeholder="Es: 18593" type="number"></b-form-input>
      </div>
      <div class="lettura">
        <div class="label">Inserisci la lettura</div>
        <b-form-input class="input" v-model="form.lettura" placeholder="00000" type="number"></b-form-input>
        <div class="subLabel">(Solo i numeri prima della virgola)</div>
      </div>
      <div class="buttonContainer">
        <b-button block class="buttonInvia" type="submit">Invia</b-button>
        <b-button block class="buttonInvia" type="reset">Reset</b-button>
      </div>
      <div class="buttonContainer">
        <b-button block class="buttonInvia" href="https://www.bioenergyspa.it/home">Torna a bioenergy</b-button>
      </div>
    </b-form>
  </div>
</template>

<script>
  import { db } from '../firebase'

  export default {
    data() {
      return {
        form: {
          contratto: '',
          contatore: '',
          lettura: '',
        },
        lunghezze: {
          lunghContr: 2,
          lunghCont: 2,
          lunghLett: 2,
        },
        letturaContatore: [],
      }
    },
    methods: {
      onSubmit(evt) {
        evt.preventDefault()
        let currentdate = new Date();
        let datetime = "Data: " + currentdate.getDate() + "/"
                + (currentdate.getMonth()+1)  + "/" 
                + currentdate.getFullYear() + " Ora: "  
                + currentdate.getHours() + ":"  
                + currentdate.getMinutes() + ":" 
                + currentdate.getSeconds();
        if(this.form.contratto && this.form.contatore && this.form.lettura !=='' ){
          db.collection('letturaContatore').add(
            {
              numero_contratto: this.form.contratto,
              numero_contatore: this.form.contatore,
              numero_lettura: this.form.lettura,
              timestamp: datetime
            }
            ).then(() => {
                      alert('Autolettura inviata correttamente');
                  }).catch((error) => {
                      console.log(error);
                  });
        }
        else{
          alert('I campi non possono essere vuoti');
        }
      },
      onReset(evt) {
        evt.preventDefault()
        // Reset our form values
        this.form.contratto = ''
        this.form.contatore = ''
        this.form.lettura = ''
      }
    }
  }
</script>

<style lang="scss" scoped>
.main{
  .label{
    font-weight: 400;
    margin-bottom: 8px;
  }
  .subLabel{
    font-weight: 300;
    font-size: 12px;
  }
  color: white;
  text-align: center;
  .input{
    margin-bottom: 8px;
    // border-radius: 100px;
  }
  .utenza{
    padding: 16px;
  }
  .lettura{
    background-color: #82ccdd;
    padding: 16px;
  }
  .buttonContainer{
    padding: 16px;
    .buttonInvia{
      background-color: #fafafa;
      color: #60a3bc;
      border-color: #60a3bc;
      text-transform: uppercase;
    }
  }
}
</style>
